import type { ReactNode } from "react";
import { MutationCache, QueryCache, QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { handleSessionTokenError } from "@/modules/auth/lib/handleSessionTokenError";

const queryClient = new QueryClient({
	queryCache: new QueryCache({
		onError: handleSessionTokenError,
	}),
	mutationCache: new MutationCache({
		onError: handleSessionTokenError,
	}),
	defaultOptions: {
		queries: {
			staleTime: 5 * 60 * 1000,
		},
	},
});

export const ReactQueryProvider = ({ children }: { children: ReactNode }) => (
	<QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
);

export { queryClient };
